"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagination = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var usePagination = function (_a) {
    var currentPage = _a.currentPage, totalPages = _a.totalPages;
    var _b = (0, react_router_dom_1.useSearchParams)(), setSearchParams = _b[1];
    // Мемоизируем состояние страниц
    var state = react_1.default.useMemo(function () { return ({
        isFirstPage: currentPage === 1,
        isLastPage: currentPage === totalPages,
    }); }, [currentPage, totalPages]);
    // Мемоизируем обработчики
    var handlers = react_1.default.useMemo(function () { return ({
        handlePageChange: function (page) {
            setSearchParams(function (prev) {
                var newParams = new URLSearchParams(prev);
                newParams.set('page', page.toString());
                return newParams;
            });
        },
        handlePrevPage: function () {
            if (!state.isFirstPage) {
                handlers.handlePageChange(currentPage - 1);
            }
        },
        handleNextPage: function () {
            if (!state.isLastPage) {
                handlers.handlePageChange(currentPage + 1);
            }
        },
    }); }, [setSearchParams, currentPage, state.isFirstPage, state.isLastPage]);
    // Мемоизируем массив номеров страниц
    var pageNumbers = react_1.default.useMemo(function () {
        var pages = [];
        if (totalPages <= 7) {
            for (var i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        }
        else {
            pages.push(1);
            if (currentPage <= 4) {
                for (var i = 2; i <= 5; i++) {
                    pages.push(i);
                }
                pages.push('...');
                pages.push(totalPages);
            }
            else if (currentPage >= totalPages - 3) {
                pages.push('...');
                for (var i = totalPages - 4; i <= totalPages; i++) {
                    pages.push(i);
                }
            }
            else {
                pages.push('...');
                for (var i = currentPage - 1; i <= currentPage + 1; i++) {
                    pages.push(i);
                }
                pages.push('...');
                pages.push(totalPages);
            }
        }
        return pages;
    }, [currentPage, totalPages]);
    return {
        pageNumbers: pageNumbers,
        handlers: handlers,
        state: state,
    };
};
exports.usePagination = usePagination;
